import { storageLocationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

/**
 * Multi-fulfillment-group variant of recordDirectBinPick. Takes the modal's
 * merged per-product bin selections and the set of fulfillment groups they
 * cover; the handler divides the selections back out to each group based on
 * that group's line-item quantities.
 */
export const recordDirectBinPicks = {
  name: "recordDirectBinPicks" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()).min(1),
    binSelections: z.record(
      z.string(),
      z.array(
        z.object({
          storageLocationId: storageLocationIdFormat.schema,
          quantity: z.number(),
        }),
      ),
    ),
  }),
  output: z.object({
    results: z.array(
      z.object({
        fulfillmentGroupId: z.string(),
        transferSessionId: z.string(),
      }),
    ),
  }),
};
